import React from 'react';
import { useHistory } from "react-router-dom";
import Popup from '../../../../components/Popup/Popup';
import styles from './Popups.module.less';
import Button from "../../../../components/Buttons/Button";
import Link from "../../../../components/Link/Link";
import useMobile from "../../../../hooks/useMobile";
import routes from "../../../../references/routes";

const StarIcon = () => (
  <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M60.5286 86.0141C60.7767 87.0317 62.2237 87.0317 62.4718 86.0141L65.4002 74L77.2224 70.9686C78.2246 70.7117 78.2246 69.2883 77.2224 69.0313L65.4002 66L62.4718 53.9858C62.2237 52.9683 60.7767 52.9683 60.5286 53.9858L57.6002 66L45.778 69.0313C44.7758 69.2883 44.7758 70.7117 45.778 70.9686L57.6002 74L60.5286 86.0141Z"
      fill="white"
    />
    <path
      d="M64.0447 50.1791C64.4234 51.694 66.5764 51.694 66.9551 50.1791L70.7999 34.7999L86.1791 30.9551C87.694 30.5764 87.694 28.4234 86.1791 28.0447L70.7999 24.1999L66.9551 8.82076C66.5764 7.30584 64.4234 7.30584 64.0447 8.82077L60.1999 24.1999L44.8208 28.0447C43.3058 28.4234 43.3058 30.5764 44.8208 30.9551L60.1999 34.7999L64.0447 50.1791Z"
      fill="white"
    />
    <path
      d="M30.4171 76.5206C31.1178 78.0973 33.3523 78.1063 34.0657 76.5353L42.6067 57.727L61.3201 49.2787C62.8896 48.5702 62.8896 46.3415 61.3201 45.633L42.6067 37.1847L34.0657 18.3764C33.3523 16.8054 31.1178 16.8144 30.4171 18.3911L22.0644 37.1847L3.17584 45.63C1.59764 46.3357 1.59764 48.576 3.17584 49.2817L22.0644 57.727L30.4171 76.5206Z"
      fill="white"
    />
    <path d="M49.8418 48.2703L47.5952 49.1636" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M71.7324 30L68.9998 30.6831" stroke="white" strokeLinecap="round"/>
    <path d="M67.3322 32.0001L66.3075 36.099" stroke="white" strokeLinecap="round"/>
    <path d="M66.3818 69.9995L63.6492 70.6827" stroke="white" strokeWidth="0.5" strokeLinecap="round"/>
    <path d="M44.8623 50.53L40.0803 52.9211" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M37.0068 57.7029L34.9574 62.1433" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
    <path
      d="M35.2471 15.249C30.9903 21.0071 13.0415 37.6896 13.041 48.2803C13.0678 61.5179 23.9996 72.2363 37.5342 72.2363C48.3717 72.2363 57.6337 65.3194 60.8184 55.7617L62.709 60.208L65.7715 67.4131C59.8053 76.5004 49.3811 82.5195 37.5342 82.5195C19.0064 82.5195 4.00008 67.8413 4 49.7197C4 34.4767 27.7308 14.0659 35.2471 8V15.249ZM37.5342 42.1553C42.6015 42.1553 46.6796 46.3312 46.6797 51.4697C46.6797 56.6075 42.5788 60.7852 37.5342 60.7852C32.4889 60.785 28.3887 56.6075 28.3887 51.4697C28.3888 46.3313 32.489 42.1554 37.5342 42.1553ZM64.8828 33.8662C68.5377 39.2498 71.0587 44.7582 71.0674 49.7197C71.0674 50.7762 71.014 51.8207 70.9141 52.8516L68.1953 57.876L63.5498 46.9482L61.7871 46.1641C61.3621 43.8677 60.3256 41.3826 58.917 38.8418L63.5498 36.9668L64.8828 33.8662ZM39.793 8C44.0195 11.411 53.3738 19.358 60.7568 28.3711L59.041 32.3613L55.6689 33.7256C50.062 25.7687 42.3784 18.1397 39.793 14.8887V8Z"
      fill="#64C800"
    />
    <path
      d="M85.2562 42.0916L73.5035 36.7546L68.2233 25.0587L62.9431 36.7546L51.1904 42.0916L62.9431 47.315L68.2233 59.1245L73.5035 47.315L85.2562 42.0916Z"
      fill="#005550"
    />
    <circle cx="37.9111" cy="51.5668" r="9.58101" fill="#005550"/>
  </svg>
);
const IntroduceAiPopup = (props: { onClosePopup: () => void, show: boolean }) => {
  const {
    onClosePopup, show,
  } = props;
  const history = useHistory();
  const isMobile = useMobile();

  return (
    <Popup
      onClose={onClosePopup}
      open={show}
      showCloseBlock
      popupClasses={styles.IntroduceAiPopup}
      maxWidth={450}
    >
      <div>
        <StarIcon/>
        <h3 className={styles.heading24}>Ask Terra</h3>
        <p className={styles.text16}>
          Your go-to for science-backed answers
          on biomarkers, activity, healthspan, and more!
        </p>
        <p className={`${styles.text16}`}>
          Tip: For easy access, click the
          {' '}
          <svg
            className={styles.IntroduceAiPopupIcon}
            width="22"
            height="24"
            viewBox="0 0 22 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.22363 4.21436C7.13716 5.83954 2.55569 10.5485 2.55566 13.5376C2.5625 17.2738 5.35316 20.2993 8.80762 20.2993C11.5007 20.2992 13.8124 18.4481 14.6826 15.8608L15.0635 16.8501L15.9229 19.0864C14.3866 21.5675 11.7721 23.2016 8.80762 23.2017C4.07876 23.2017 0.248099 19.0585 0.248047 13.9438C0.248047 9.64167 6.30525 3.8805 8.22363 2.16846V4.21436ZM8.80762 11.8091C10.1009 11.8092 11.1416 12.9877 11.1416 14.438C11.1415 15.8879 10.095 17.0668 8.80762 17.0669C7.51996 17.0669 6.47277 15.888 6.47266 14.438C6.47266 12.9877 7.51988 11.8091 8.80762 11.8091ZM15.7871 9.47119C16.7196 10.9903 17.364 12.5439 17.3662 13.9438C17.3662 14.2433 17.3519 14.5394 17.3262 14.8315L16.6338 16.2466L15.4482 13.1626L14.9971 12.9409C14.8887 12.2927 14.6233 11.5918 14.2637 10.8745L15.4482 10.3452L15.7871 9.47119ZM9.38379 2.16846C10.4441 3.1147 12.7682 5.29864 14.6367 7.78857L14.1289 9.09326L13.4209 9.40967C11.991 7.17148 10.0416 5.02751 9.38379 4.11279V2.16846Z"
              fill="#232D37"
            />
            <path
              d="M20.9876 11.7908L17.988 10.2845L16.6403 6.98341L15.2926 10.2845L12.293 11.7908L15.2926 13.265L16.6403 16.5981L17.988 13.265L20.9876 11.7908Z"
              fill="#232D37"
            />
            <ellipse cx="8.90338" cy="14.4651" rx="2.44537" ry="2.70414" fill="#232D37"/>
          </svg>
          {' '}
          icon at the top of the page.
        </p>
        <Button
          onClick={() => {
            history.push(routes.customer.askIt);
            onClosePopup();
          }}
          green
          superLarge={!isMobile}
          id="ask-it-start"
          text="Let’s start"
          className={styles.IntroduceAiPopupBtn}
        />
        <Link
          onClick={() => {
            onClosePopup();
          }}
          id="ask-it-later"
          className={styles.IntroduceAiPopupLink}
        >
          Maybe later
        </Link>
      </div>
    </Popup>
  );
};

export default IntroduceAiPopup;
